import React from 'react';
import { FormattedText } from 'core/i18n';
import { LegalModal } from './LegalModal/LegalModal';

export const LegalListItem = ({ index, productsInfo }) => {
    const text = `documentation-gdprLegalIndex${index}`;
    const anchor = `info_${index}`;

    return (
        <li key={index}>
            <FormattedText value={text} />
            <span className="legal-info__span">
                <LegalModal anchor={anchor} productsInfo={productsInfo} />
            </span>
        </li>
    );
};
